/**
 * ICD-203 and Best practices cards are rows in report_tasks. They stay in the
 * database so Ctrl+Z after Replace Text can show the same card again. The Tools
 * list hides a card when its paragraph is gone or no longer contains the flagged
 * text (MINSKY-17884).
 */

const MARKUP_TASK_TYPES = new Set(['compliance_check', 'best_practices_check']);

export function isMarkupSuggestion(task) {
    return MARKUP_TASK_TYPES.has(task?.taskType);
}

function findBlockTexts(doc, blockId) {
    if (!doc || !blockId) return null;
    const texts = [];
    doc.descendants((node) => {
        if (node.isBlock && node.attrs?.blockId === blockId) {
            texts.push(node.textContent || '');
        }
        return true;
    });
    return texts.length ? texts : null;
}

function normalizeText(value) {
    return value.replace(/\s+/g, ' ').trim();
}

function spanWasLocated(task) {
    const range = task?.range;
    if (!Array.isArray(range) || range.length < 2) return false;
    const start = Number(range[0]);
    const end = Number(range[1]);
    return Number.isFinite(start) && Number.isFinite(end) && end > start;
}

/**
 * @returns {boolean} true when the card should stay in the Tools list
 */
export function suggestionStillApplies(task, doc) {
    if (!isMarkupSuggestion(task)) return true;
    if (!doc) return true;
    const texts = findBlockTexts(doc, task?.blockId);
    if (texts == null) return false;
    const flagged = typeof task.originalText === 'string' ? task.originalText : '';
    if (!flagged) return true;
    const needle = normalizeText(flagged);
    if (!needle) return true;
    if (texts.some((text) => normalizeText(text).includes(needle))) return true;
    // The checker often returns flagged text that was never a substring of the
    // paragraph. Those cards still belong to the block. Hide only a span that
    // was located and that the draft no longer contains.
    return !spanWasLocated(task);
}

export function filterApplicableSuggestions(tasks, doc) {
    if (!Array.isArray(tasks)) return [];
    return tasks.filter((task) => suggestionStillApplies(task, doc));
}
